module.exports = __webpack_public_path__ + "img/Duffy-Background.png";